import L from 'leaflet';
import React from 'react';
import ReactDOM from 'react-dom';
import {
  map, PopupBehavior, SetLastInsertedId, SetLastOpenedPopup,
  GetUserPermissions, isMobileVersion, loadedMarkers,
  DeleteObjectWithConfirm, StartCurveLine, OpenSideBar,
  SetCurrentBottomSheet, GetUserId, GetUserName, HighlightMarker, ClearMarkerHighlight
} from './Main.js';
import { SearchComponent } from "../react-components/search/SearchComponent";
import { DrawMainMarker, SetLastInsertedMarker } from './MarkerManager.js';
import { GetLastLinkedObj, SetLastLinkedObj } from './PPManager.js';
import { CheckLinkedtpIsPS } from './PoleManager.js';
import { updatePolylineByFromId, updatePolylineByToId, AddLine } from './lines.js';
import { ObjectBottomSheet } from '../react-components/mobile/ObjectBottomSheet';
import { AddLineSheet } from '../react-components/mobile/AddLineSheet';
import { EditObjectSheet } from '../react-components/mobile/EditObjectSheet';

var lastMyDiv = null;
var choosedLinkedtp = null;

function handeleClickFindPP(id, name, lat, lng) {
  choosedLinkedtp = name;
}

export function AddObjectSetup(latlng, currentTime, config) {
  const btn = document.getElementById(`${config.buttonKey}-btn${currentTime}`);
  if (!btn) return;

  btn.addEventListener('click', function () {
    if (isMobileVersion) {
      const container = document.createElement('div');
      document.body.appendChild(container);
      SetCurrentBottomSheet(container);

      const handleClose = () => {
        ReactDOM.unmountComponentAtNode(container);
        container.remove();
      };

      const searchLink = `${process.env.REACT_APP_BASE_URL}/api/objects_list/searchPP?name=`;

      ReactDOM.render(
        <EditObjectSheet
          title={`Добавить ${config.label}`}
          numberLabel={`Номер ${config.label}`}
          initialNumber=""
          initialLinkedtp={choosedLinkedtp || ""}
          initialTextPosition={0}
          searchLink={searchLink}
          onClose={handleClose}
          onSave={(number, linkedtp, textPosition) => {
            CheckLinkedtpIsPS(linkedtp).then(isValidPS => {
              if (!isValidPS) {
                alert('Указанный питающий центр не найден среди ПС');
                return;
              }
              AddObjectDirect(latlng, number, linkedtp, textPosition, config);
              handleClose();
            });
          }}
        />,
        container
      );
      return;
    }

    // Десктоп — HTML popup
    var polePopupDiv = document.createElement('div');
    polePopupDiv.id = `${config.buttonKey}Popup`;
    document.body.appendChild(polePopupDiv);
    polePopupDiv.innerHTML = GetObjectHtmlContent('', GetLastLinkedObj(), config);

    const searchLinkPP = `${process.env.REACT_APP_BASE_URL}/api/objects_list/searchPP?name=`;
    const searchContainer = document.getElementById('divMainObjectNumber');

    ReactDOM.render(
      <div className="div__flex">
        <label>Питающий центр: </label>
        <div id="mainObjectNumber">
          <SearchComponent
            handeleClickFind={handeleClickFindPP}
            link={searchLinkPP}
            home={false}
            propsValue={choosedLinkedtp || ""}
          />
        </div>
      </div>,
      searchContainer
    );

    var popup = L.popup().setContent(polePopupDiv).setLatLng(latlng).openOn(map);
    polePopupDiv.parentElement.style.width = "350px";

    document.getElementById(`save${config.buttonKey}`).addEventListener('click', function () {
      this.disabled = true;
      var objectNumber = document.getElementById(`${config.buttonKey}Number`).value;
      SaveObject(false, null, latlng, popup, null, objectNumber, null, this, config);
    });
  });
}

function AddObjectDirect(latlng, objectNumber, linkedtp, textPosition, config) {
  fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/insertObject`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      name: objectNumber, linkedtp, typecode: config.typecode,
      lat: latlng.lat, lng: latlng.lng, textPosition,
      userId: GetUserId(), username: GetUserName()
    })
  })
  .then((response) => {
    if (!response.ok) {
      return response.json().then((errData) => {
        throw new Error(errData.error || `Ошибка сервера: ${response.status}`);
      });
    }
    return response.json();
  })
  .then(response => {
    const objectId = response.id;
    SetLastInsertedId(objectId);

    var circle = DrawMainMarker(latlng, objectNumber, config.typecode, textPosition, null, objectId, linkedtp).addTo(map);
    loadedMarkers.set(objectId, circle);
    SetLastInsertedMarker(circle);
    ObjectPopupSetup(circle, objectNumber, linkedtp, latlng.lat, latlng.lng, objectId, config);
    PopupBehavior(circle, objectId, latlng, linkedtp, config.typecode, objectNumber);
  })
  .catch(error => {
    console.error(`Ошибка добавления ${config.label}:`, error);
    alert(`Не удалось добавить ${config.label}: ${error.message}`);
  });
}

export function EditObjectSetup(id, latlng, iMarker, config) {
  fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/get_object_by_id/${id}`)
    .then(response => response.json())
    .then(data => {
      data.forEach(obj => {
        choosedLinkedtp = obj.linkedtp;

        if (isMobileVersion) {
          const container = document.createElement('div');
          document.body.appendChild(container);
          SetCurrentBottomSheet(container);

          const handleClose = () => {
            ReactDOM.unmountComponentAtNode(container);
            container.remove();
            ClearMarkerHighlight(iMarker); // редактирование закончено (сохранили или закрыли)
          };

          const handleBack = () => {
            ReactDOM.unmountComponentAtNode(container);
            container.remove();
            if (iMarker) iMarker.fire('click'); // снова откроется шторка объекта, выделение остаётся
          };

          const searchLink = `${process.env.REACT_APP_BASE_URL}/api/objects_list/searchPP?name=`;

          ReactDOM.render(
            <EditObjectSheet
              title={`Редактировать ${config.label}`}
              numberLabel={`Номер ${config.label}`}
              initialNumber={obj.name}
              initialLinkedtp={obj.linkedtp}
              initialTextPosition={obj.textPosition}
              searchLink={searchLink}
              onClose={handleClose}
              onBack={handleBack}
              onSave={(number, linkedtp, textPosition) => {
                CheckLinkedtpIsPS(linkedtp).then(isValidPS => {
                  if (!isValidPS) {
                    alert('Указанный питающий центр не найден среди ПС');
                    return;
                  }
                  EditObjectDirect(id, latlng, iMarker, number, linkedtp, textPosition, obj.name, config);
                  handleClose();
                });
              }}
            />,
            container
          );
          return;
        }

        // Десктоп — HTML popup
        var polePopupDiv = document.createElement('div');
        polePopupDiv.id = `${config.buttonKey}Popup`;
        document.body.appendChild(polePopupDiv);
        polePopupDiv.innerHTML = GetObjectHtmlContent(obj.name, obj.linkedtp, config);

        const searchLinkPP = `${process.env.REACT_APP_BASE_URL}/api/objects_list/searchPP?name=`;
        const searchContainer = document.getElementById('divMainObjectNumber');

        ReactDOM.render(
          <div className="div__flex">
            <label>Питающий центр: </label>
            <div id="mainObjectNumber">
              <SearchComponent
                handeleClickFind={handeleClickFindPP}
                link={searchLinkPP}
                home={false}
                propsValue={obj.linkedtp}
              />
            </div>
          </div>,
          searchContainer
        );

        var popup = L.popup().setContent(polePopupDiv).setLatLng(latlng).openOn(map);
        // openOn закрыл попап объекта (и снял выделение) — выделяем снова на время
        // редактирования; снимется при закрытии формы (в т.ч. после сохранения)
        if (iMarker) {
          HighlightMarker(iMarker);
          popup.on('remove', () => ClearMarkerHighlight(iMarker));
        }
        polePopupDiv.parentElement.style.width = "350px";
        document.getElementById("textPosition").value = obj.textPosition;

        document.getElementById(`save${config.buttonKey}`).addEventListener('click', function () {
          this.disabled = true;
          var objectNumber = document.getElementById(`${config.buttonKey}Number`).value;
          SaveObject(true, id, latlng, popup, iMarker, objectNumber, obj.name, this, config);
        });
      });
    });
}

function EditObjectDirect(id, latlng, iMarker, objectNumber, linkedtp, textPosition, oldName, config) {
  fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/updateObject`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      name: objectNumber, linkedtp, typecode: config.typecode, textPosition, id,
      userId: GetUserId(), username: GetUserName()
    })
  })
  .then((response) => {
    if (!response.ok) {
      return response.json().then((errData) => {
        throw new Error(errData.error || `Ошибка сервера: ${response.status}`);
      });
    }
    return response.json();
  })
  .then(() => {
    choosedLinkedtp = linkedtp;

    var circle = DrawMainMarker(latlng, objectNumber, config.typecode, textPosition, iMarker, id, linkedtp).addTo(map);
    loadedMarkers.set(id, circle);
    ObjectPopupSetup(circle, objectNumber, linkedtp, latlng.lat, latlng.lng, id, config);
    PopupBehavior(circle, id, latlng, linkedtp, config.typecode, objectNumber);

    updatePolylineByFromId(id, objectNumber);
    updatePolylineByToId(id, objectNumber);
  })
  .catch(error => {
    console.error(`Ошибка обновления ${config.label}:`, error);
    alert(`Не удалось сохранить ${config.label}: ${error.message}`);
  });
}

function SaveObject(isEdit, id, latlng, popup, iMarker, objectNumber, oldNumber, button, config) {
  if (!choosedLinkedtp) {
    document.getElementById("errorText").textContent = "Не выбран питающий центр";
    button.disabled = false;
    return;
  }
  CheckLinkedtpIsPS(choosedLinkedtp).then(isValidPS => {
    if (!isValidPS) {
      document.getElementById("errorText").textContent = "Указанный питающий центр не найден среди ПС";
      button.disabled = false;
      return;
    }
    const encodedNumber = encodeURIComponent(objectNumber);
    fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/${config.checkDuplicateEndpoint}/${encodedNumber}`)
      .then(response => response.json())
      .then(data => {
        if (data.length > 0 && oldNumber != data[0].name) {
          document.getElementById("errorText").textContent = `${config.label} с таким номером уже существует`;
          button.disabled = false;
        } else {
          if (!isEdit) {
            AddObjectDirect(latlng, objectNumber, choosedLinkedtp, parseInt(document.getElementById('textPosition').value), config);
          } else {
            EditObjectDirect(id, latlng, iMarker, objectNumber, choosedLinkedtp, parseInt(document.getElementById('textPosition').value), oldNumber, config);
          }
          map.closePopup(popup);
        }
      });
  });
}

export function ObjectPopupSetup(circle, name, linkedtp, lat, lng, id, config) {
  var isEditable = false;
  var departmentAccessArray = GetUserPermissions();
  const entry = departmentAccessArray.find(entry => {
    if (linkedtp === null) return entry.startsWith("00=");
    return entry.startsWith(linkedtp.substring(0, 2) + "=") || entry.startsWith("00=");
  });
  if (entry) {
    const value = entry.split("=")[1];
    isEditable = (value === '1' || value === '2');
  }


  var editButtons = `<button id="editObject${id}" class="simple_button">Редактировать</button><button id="deleteObject${id}" class="simple_button">Удалить</button><button id="addLine${id}" class="simple_button">Добавить линию</button><button id="passport${id}" class="simple_button">Паспорт</button>`;
  if (!isEditable) {
    editButtons = `<button id="editObject${id}" class="simple_button" style="display: none;">Редактировать</button><button id="deleteObject${id}" class="simple_button" style="display: none;">Удалить</button><button id="addLine${id}" class="simple_button" style="display: none;">Добавить линию</button>`;
  }

  circle.off('click');
  circle.on('click', function () {
    const latlng = circle.getLatLng();

    if (!isMobileVersion) {
      if (lastMyDiv) lastMyDiv.remove();
      var popupContent = `<b>${config.titlePrefix}${name}</b><br>${editButtons}`;
      var myDiv = document.createElement('div');
      myDiv.innerHTML = popupContent;
      var popup = L.popup().setContent(myDiv).setLatLng(latlng).openOn(map);
      SetLastOpenedPopup(popup);
      lastMyDiv = myDiv;
      // Выделяем после openOn: он закрывает предыдущий попап, и если это был попап
      // этого же объекта, его 'remove' снял бы только что поставленное выделение
      HighlightMarker(circle);
      popup.on('remove', () => ClearMarkerHighlight(circle));
      return;
    }

    HighlightMarker(circle);

    // Мобильный — Bottom Sheet
    const container = document.createElement('div');
    document.body.appendChild(container);
    SetCurrentBottomSheet(container);

    // При переходе к редактированию или добавлению линии шторка объекта закрывается,
    // но выделение оставляем — его снимет следующая форма (сохранение / закрытие)
    let keepHighlight = false;

    const handleClose = () => {
      ReactDOM.unmountComponentAtNode(container);
      container.remove();
      if (!keepHighlight) ClearMarkerHighlight(circle);
    };

    const handleAddLine = () => {
      const addLineContainer = document.createElement('div');
      document.body.appendChild(addLineContainer);
      SetCurrentBottomSheet(addLineContainer);

      // Если начали рисовать кривую линию — выделение держим до конца рисования
      // (его снимет обработчик DRAWSTOP в Main.js)
      let curveStarted = false;

      const handleAddLineClose = () => {
        ReactDOM.unmountComponentAtNode(addLineContainer);
        addLineContainer.remove();
        if (!curveStarted) ClearMarkerHighlight(circle);
      };

      const handleAddLineBack = () => {
        ReactDOM.unmountComponentAtNode(addLineContainer);
        addLineContainer.remove();
        circle.fire('click');
      };

      const searchLink = `${process.env.REACT_APP_BASE_URL}/api/objects_list/getAllPolesByName?linkedtp=${linkedtp}&name=`;
      const markerLatlng = circle.getLatLng();

      const handleAddLineSubmit = (selectedObject, typecode) => {
        if (typecode === '7c') {
          curveStarted = true;
          StartCurveLine(markerLatlng, {
            from_id: id, to_id: selectedObject.id, typecode: '7', linkedtp,
            start_name: name, end_name: selectedObject.name,
            start_lat: markerLatlng.lat, start_lng: markerLatlng.lng,
            end_lat: selectedObject.lat, end_lng: selectedObject.lng
          }, circle);
        } else {
          AddLine(id, selectedObject.id, typecode, markerLatlng.lat, markerLatlng.lng,
            selectedObject.lat, selectedObject.lng, linkedtp, name, selectedObject.name);
        }
      };

      ReactDOM.render(
        <AddLineSheet
          onClose={handleAddLineClose}
          onAddLine={handleAddLineSubmit}
          searchLink={searchLink}
          onBack={handleAddLineBack}
        />,
        addLineContainer
      );
    };

    ReactDOM.render(
      <ObjectBottomSheet
        title={`${config.titlePrefix}${name}`}
        id={id}
        typecode={config.typecode}
        isEditable={isEditable}
        onClose={handleClose}
        onEdit={() => { keepHighlight = true; EditObjectSetup(id, circle.getLatLng(), circle, config); }}
        onDelete={() => DeleteObjectWithConfirm(id, circle)}
        onAddLine={() => { keepHighlight = true; handleAddLine(); }}
        onPassport={() => OpenSideBar(true)}
      />,
      container
    );
  });
}

function GetObjectHtmlContent(objectName, linkedtp, config) {
  var numberContent = `<label for="${config.buttonKey}Number">Номер ${config.label}: </label><input type="text" id="${config.buttonKey}Number" value="${objectName}">`;
  var mainObjectNumberContent = '<br><div id="divMainObjectNumber"></div><br>';
  var textPosition = `<label>Расположение номера: </label>
    <select name="textPosition" id="textPosition">
      <option value="0">Сверху</option>
      <option value="1">Справа</option>
      <option value="2">Снизу</option>
      <option value="3">Слева</option>
    </select><br>`;
  var submitContent = `<br><button id="save${config.buttonKey}" class="simple_button">Сохранить</button><span class="error-text" id="errorText"></span>`;

  return numberContent + mainObjectNumberContent + textPosition + submitContent;
}